module.exports = __webpack_public_path__ + "img/friends-img-eng.285b0225.png";